// extracted by mini-css-extract-plugin
module.exports = {"globalLoader":"GlobalLoader_globalLoader__Jwij4","local":"GlobalLoader_local__2Ava7","centered":"GlobalLoader_centered__gVCLR"};